const styleSheet = () => ({
  clickableArea: {
    position: 'relative',
    boxSizing: 'border-box',
    cursor: 'pointer',
    // padding: (props: any) =>
    //   (props.overrideStyles && props.overrideStyles.padding) || "4px",
    margin: (props: any) =>
      (props.overrideStyles && props.overrideStyles.margin) || '0px',
    display: (props: any) =>
      (props.overrideStyles && props.overrideStyles.display) || 'flex',
    verticalAlign: (props: any) =>
      (props.overrideStyles && props.overrideStyles.verticalAlign) ||
      'baseline',
    width: 'max-content',
    userSelect: 'auto !important',
  },
  indeterminate: {
    height: '2px',
    width: '8px',
    backgroundColor: '#fff',
    marginLeft: '3px',
    marginTop: '6px',
  },
  label: {
    whiteSpace: 'nowrap',
    marginLeft: '10px',
    color: (props: any) => (props.isChecked ? '#085FE5' : '#6373A4'),
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '15px',
    userSelect: 'none',
  },
  whiteBox: {
    position: 'relative',
    boxSizing: 'border-box',
    height: '16px',
    width: '16px',
    border: '1.2px solid #D8DCE6',
    borderRadius: '3px',
    background: 'linear-gradient(0deg, #F6F7F9 0%, #FFFFFF 100%)',
    display: (props: any) =>
      (props.overrideStyles && props.overrideStyles.whiteBoxDisplay) ||
      'inline-block',
  },
  checkedBox: {
    background: (props: any) => props.overrideStyles?.checkedColor || '#085FE5',
    borderColor: (props: any) =>
      props.overrideStyles?.checkedColor || '#085FE5',
  },
  checkContainer: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    '& svg': {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
    },
  },
  check: {
    '& path': {
      fill: (props: any) => props.checkmarkColor || '#FFFFFF',
    },
  },
  checked: {
    background: '#085FE5',
  },
});

export default styleSheet;
